import {
  Baby,
  BadgeCheck,
  BookOpen,
  Briefcase,
  Building2,
  Calendar,
  ClipboardList,
  DollarSign,
  FileText,
  Gift,
  GraduationCap,
  Handshake,
  Heart,
  HeartHandshake,
  Landmark,
  Laptop,
  LockKeyhole,
  MapPin,
  Megaphone,
  Plane,
  Scale,
  Settings,
  Shield,
  Stethoscope,
  Tags,
  TrendingUp,
  UserCheck,
  Users,
  Wallet,
} from 'lucide-react';
import { DynamicLucideIcon, normalizeLucideIconName } from '@/components/LucideIconPicker';

export const TOPIC_ICON_OPTIONS = [
  { value: 'Heart', label: 'Heart' },
  { value: 'DollarSign', label: 'Dollar' },
  { value: 'Calendar', label: 'Calendar' },
  { value: 'Shield', label: 'Shield' },
  { value: 'Tag', label: 'Tag' },
  { value: 'TrendingUp', label: 'Trending' },
  { value: 'GraduationCap', label: 'Education' },
  { value: 'Settings', label: 'Settings' },
  { value: 'Users', label: 'Users' },
  { value: 'Briefcase', label: 'Work' },
  { value: 'Building2', label: 'Office' },
  { value: 'ClipboardList', label: 'Checklist' },
  { value: 'FileText', label: 'Document' },
  { value: 'Landmark', label: 'Legal' },
  { value: 'Plane', label: 'Travel' },
  { value: 'Stethoscope', label: 'Healthcare' },
  { value: 'UserCheck', label: 'Eligibility' },
  { value: 'Wallet', label: 'Compensation' },
  { value: 'Scale', label: 'Policy' },
  { value: 'BookOpen', label: 'Learning' },
  { value: 'Megaphone', label: 'Announcements' },
  { value: 'Handshake', label: 'Relations' },
  { value: 'LockKeyhole', label: 'Security' },
  { value: 'MapPin', label: 'Location' },
  { value: 'BadgeCheck', label: 'Certification' },
  { value: 'Laptop', label: 'Systems' },
  { value: 'Gift', label: 'Rewards' },
  { value: 'Baby', label: 'Parental Leave' },
  { value: 'HeartHandshake', label: 'Support' },
];

export const TOPIC_ICON_MAP = {
  Baby,
  BadgeCheck,
  BookOpen,
  Briefcase,
  Building2,
  Heart,
  DollarSign,
  Calendar,
  ClipboardList,
  FileText,
  Gift,
  TrendingUp,
  Shield,
  GraduationCap,
  Handshake,
  HeartHandshake,
  Landmark,
  Laptop,
  LockKeyhole,
  MapPin,
  Megaphone,
  Plane,
  Scale,
  Settings,
  Stethoscope,
  UserCheck,
  Users,
  Wallet,
  Tag: Tags,
  Tags,
};

export function getTopicIconComponent(icon) {
  const normalizedIcon = normalizeLucideIconName(icon);
  if (TOPIC_ICON_MAP[normalizedIcon]) return TOPIC_ICON_MAP[normalizedIcon];
  if (!normalizedIcon) return Tags;
  return function TopicDynamicIcon(props) {
    return <DynamicLucideIcon icon={normalizedIcon} {...props} />;
  };
}
